import React, { Component } from "react";
import * as Icon from "react-feather";

import ToolsActivityList from "../clients/Tools/kit/ToolsActivityList";
import UtilityService from "../../services/UtilityService";

const STATUS_BY_STEP_KIND = { refused: "attention", error: "error" };
const STEP_ANCHOR_PREFIX = "run-step-";
const SCRIPT_STEP_CHIP = "Script";

class AgentRunSteps extends Component {
	constructor(props) {
		super(props);
		this.state = { isOpen: false };
	}

	componentDidUpdate(previousProps) {
		const { highlightedSequences = [] } = this.props;
		const isNewHighlight = highlightedSequences.length > 0 && highlightedSequences !== previousProps.highlightedSequences;
		if (!isNewHighlight) return;
		const firstHighlighted = document.getElementById(STEP_ANCHOR_PREFIX + highlightedSequences[0]);
		if (firstHighlighted) firstHighlighted.scrollIntoView({ behavior: "smooth", block: "center" });
	}

	onToggle = () => {
		const { highlightedSequences = [], onClearHighlight } = this.props;
		const isOpen = this.state.isOpen || highlightedSequences.length > 0;
		if (isOpen && onClearHighlight) onClearHighlight();
		this.setState({ isOpen: !isOpen });
	};

	describeStep({ step }) {
		const chip = step.isScriptStep ? SCRIPT_STEP_CHIP : null;
		if (step.label) return { label: step.label, chip };
		if (step.sequence === 1) return { label: "Getting ready", chip };
		const isLaterAttemptSetUp = step.playbook_step === null && !!step.input && Number(step.input.attempt) > 1;
		if (isLaterAttemptSetUp) return { label: `Picked up again · attempt ${step.input.attempt}`, chip };
		if (step.kind === "model_turn") return { label: "Thinking", chip };
		return { label: step.tool_name, chip };
	}

	itemsFor({ steps, isLive }) {
		const { highlightedSequences = [] } = this.props;
		const timedSteps = steps.filter(step => Number(step.duration_ms) > 0 && !step.superseded_at);
		const slowestStep = timedSteps.reduce((slowest, step) => (!slowest || Number(step.duration_ms) > Number(slowest.duration_ms) ? step : slowest), null);
		const items = steps.map(step => {
			const isSlowest = !isLive && !!slowestStep && step.sequence === slowestStep.sequence;
			const hasNote = step.kind === "refused" || step.kind === "error";
			const isSetAside = !!step.superseded_at;
			const { label, chip } = this.describeStep({ step });
			return {
				key: step.sequence,
				anchorId: STEP_ANCHOR_PREFIX + step.sequence,
				status: STATUS_BY_STEP_KIND[step.kind] || "done",
				label,
				chip,
				note: hasNote ? step.output : null,
				detail: isSetAside ? "Earlier attempt" : null,
				value: UtilityService.describeDuration({ milliseconds: step.duration_ms }),
				valueTag: isSlowest ? "slowest" : null,
				isEmphasised: isSlowest,
				isHighlighted: highlightedSequences.includes(step.sequence),
				isSetAside,
			};
		});
		if (isLive) items.push({ key: "now", status: "working", label: "Thinking" });
		return items;
	}

	renderLive() {
		const { steps } = this.props;
		const lastLabelledStep = [...steps].reverse().find(step => step.label);
		const lastFinishedText = lastLabelledStep ? `Last step finished: ${lastLabelledStep.label}. ` : "";
		return (
			<ToolsActivityList
				status={steps.length > 0 ? "Working…" : "Starting…"}
				substatus={`${lastFinishedText}Writing the report can take a minute or two. This page updates by itself; you can leave and come back.`}
				isWorking
				items={this.itemsFor({ steps, isLive: true })}
			/>
		);
	}

	render() {
		const { steps, run, isLive, highlightedSequences = [] } = this.props;
		if (isLive) return this.renderLive();
		const isOpen = this.state.isOpen || highlightedSequences.length > 0;
		const hasEnded = !!run.started_at && !!run.finished_at;
		const totalTime = hasEnded ? UtilityService.describeDuration({ milliseconds: new Date(run.finished_at) - new Date(run.started_at) }) : null;
		const setAsideCount = steps.filter(step => !!step.superseded_at).length;
		const currentCount = steps.length - setAsideCount;
		const setAsideText = setAsideCount > 0 ? ` · ${setAsideCount} from an earlier attempt` : "";

		return (
			<section className="agent-run-report__group">
				<button type="button" className="agent-run-report__toggle" onClick={this.onToggle} aria-expanded={isOpen}>
					{isOpen ? <Icon.ChevronDown size={14} /> : <Icon.ChevronRight size={14} />}
					How the agent worked · {currentCount} steps{setAsideText}
					{totalTime && ` · ${totalTime}`}
				</button>
				{isOpen && <ToolsActivityList items={this.itemsFor({ steps, isLive: false })} />}
			</section>
		);
	}
}

export default AgentRunSteps;
